import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import { useContract } from '../../context/ContractContext';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import ReferralLink from '../../components/team/ReferralLink/ReferralLink';
import TeamStats from '../../components/team/TeamStats/TeamStats';
import BinaryTree from '../../components/team/BinaryTree/BinaryTree';
import './Team.css';

const Team = () => {
  const navigate = useNavigate();
  const { isConnected, isInitializing } = useWallet();
  const { isRegistered, isCheckingRegistration, userId, getDirectInfo, getBinaryInfo } = useContract();

  const [activeTab, setActiveTab] = useState('tree');
  const [directInfo, setDirectInfo] = useState(null);
  const [binaryInfo, setBinaryInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isInitializing || isCheckingRegistration) return;
    
    if (!isConnected) {
      navigate('/');
      return;
    }
    if (!isRegistered) {
      navigate('/register');
      return;
    }
  }, [isConnected, isRegistered, isInitializing, isCheckingRegistration, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) return;
      
      try {
        const [direct, binary] = await Promise.all([
          getDirectInfo(),
          getBinaryInfo()
        ]);
        
        setDirectInfo(direct);
        setBinaryInfo(binary);
      } catch (err) {
        console.error('Error fetching team data:', err);
      }
      setLoading(false);
    };

    fetchData();
  }, [userId]);

  return (
    <PageContainer title="Team">
      <div className="team-page">
        <ReferralLink userId={userId} />

        <div className="team-tabs">
          <button 
            className={`team-tab ${activeTab === 'tree' ? 'active' : ''}`}
            onClick={() => setActiveTab('tree')}
          >
            Binary Tree
          </button>
          <button 
            className={`team-tab ${activeTab === 'stats' ? 'active' : ''}`}
            onClick={() => setActiveTab('stats')}
          >
            Team Stats
          </button>
        </div>

        {activeTab === 'tree' ? (
          <div className="team-tree-container">
            <BinaryTree rootUserId={userId} />
          </div>
        ) : (
          <div className="team-stats-container">
            <TeamStats 
              binaryInfo={binaryInfo} 
              directInfo={directInfo} 
              loading={loading} 
            />

            <div className="binary-business">
              <h3 className="section-title">Binary Business</h3>
              <div className="business-comparison">
                <div className="business-side left">
                  <span className="business-label">Left Side</span>
                  <span className="business-value">{binaryInfo?.leftBusinessTotal || '0'}</span>
                  <span className="business-unit">USDT</span>
                </div>
                <div className="business-divider">
                  <span className="vs">VS</span>
                </div>
                <div className="business-side right">
                  <span className="business-label">Right Side</span>
                  <span className="business-value">{binaryInfo?.rightBusinessTotal || '0'}</span>
                  <span className="business-unit">USDT</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default Team;